import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "platform", "button", "submitButton" ]

  connect() {
    // console.log("Hello, Recap Publishing Platforms Controller here!", this.element)
  }

  selectPlatform(event) {
    // console.log("selectPlatform", event);
    // console.log(this.platformTargets);

    const platform = event.currentTarget.dataset.platform;

    // console.log("Platform: ", platform);

    this.buttonTargets.forEach(elm => elm.classList.remove('color-fanword-black'));
    this.buttonTargets.find(elm => elm.dataset.platform === platform).classList.add('color-fanword-black');

    this.platformTargets.forEach(elm => elm.checked = false);
    this.platformTargets.find(elm => elm.value === platform).checked = true;

    this.submitButtonTarget.disabled = false;
  }

}
